<template>
    <div class="alert" v-prevent-overscroll>
        <div class="alert-area">
             <div class="address-wrapper" :style="wrapperStyle">
                <div class="form-list" :style="formStyle">
                    <div class="form-item" :key="index" v-for="(item, index) in formList">
                        <label class="form-label" :style="labelStyle">{{item.title}}：</label>
                        <template v-if="item.paramName == 'name'">
                            <input
                                :style="lineStyle"
                                maxlength="15"
                                class="form-input"
                                type="text"
                                :placeholder="item.tips"
                                v-model.trim="submitInfo.name"
                            />
                        </template>
                        <template v-if="item.paramName=='phone'">
                            <input
                                :style="lineStyle"
                                maxlength="11"
                                class="form-input"
                                type="text"
                                :placeholder="item.tips"
                                v-model.trim="submitInfo.phone"
                            />
                        </template>
                        <template v-if="item.paramName=='address'">
                            <textarea
                                :style="lineStyle"
                                maxlength="500"
                                class="form-textarea"
                                rows="3"
                                :placeholder="item.tips"
                                v-model.trim="submitInfo.address"
                                contenteditable="true"
                            ></textarea>
                        </template>
                        <template v-if="item.paramName=='remark'">
                            <input
                                :style="lineStyle"
                                maxlength="500"
                                class="form-input"
                                type="text"
                                :placeholder="item.tips"
                                v-model.trim="submitInfo.remark"
                            />
                        </template>
                        <template v-if="item.paramName=='other'">
                            <textarea
                                :style="lineStyle"
                                maxlength="500"
                                class="form-textarea"
                                rows="3"
                                :placeholder="item.tips"
                                v-model.trim="submitInfo.other"
                                contenteditable="true"
                            ></textarea>
                        </template>
                    </div>
                </div>
                <div class="submit-btn" :style="submitStyle" v-debounce:submitAddressTrigger.prevent>
                </div>
            </div>
            <div class="close-area">
                <div class="close-border"></div>
                <img class="close-icon" :src="closeIconUrl" @click.stop="closeEditAddress" />
            </div>
        </div>
    </div>
</template>

<script>

let closeIcon = require('@/assets/imgs/close.png')

export default {

    name: 'editAddress',

    props: {

        info: {
            type: Object,
        },

    },

    data() {

        return {

            closeIconUrl: closeIcon,

            wrapperStyle: {}, // 包裹框样式

            formStyle: {}, // 表单样式

            submitStyle: {}, // 提交按钮样式

            labelStyle: {}, // 标签样式

            lineStyle: {}, // 表单样式

            formList: [], // 表单列表

            submitInfo: {}, // 提交的信息

        }

    },

    mounted() {

        this.init()

    },

    methods: {

        init() {

            this.initStyle(this.info)

            this.initForm(this.info.$model, this.info.formConfig.formList)

        },

        initStyle(val) {
            let { baseConfig, formConfig, submitBtn } = val

            let transform = (config, imgKey) => {

                let options = {}

                if (config.position1 && config.position1.type) {
                    options[`${config.position1.type}`] =  `${config.position1.value || 0}px`
                }

                if (config.position2 && config.position2.type) {
                    options[`${config.position2.type}`] =  `${config.position2.value || 0}px`
                }

                if (config.width) {
                    options.width = `${config.width}px`
                }

                if (config.height) {
                    options.height = `${config.height}px`
                }

                options.color       = config.color
                options.borderColor = config.color
                options.fontSize    = `${config.fontSize}px`
                options.textStroke  = config.stroke ? `1px ${config.stroke}` : ''
                options.fontWeight  = config.fontStyle && config.fontStyle.indexOf('bold') !== -1 ? 'bold' : ''
			    options.fontStyle   = config.fontStyle && config.fontStyle.indexOf('italic') !== -1 ? 'italic' : ''

                if (imgKey) {
                    if (config[imgKey] && config[imgKey].url) {
                        let background = {
                            backgroundImage: `url(${config[imgKey].url})`,
                            backgroundSize: `100% 100%`,
                            backgroundPosition: '0px 0px',
                        }
                        options= Object.assign(options, background)
                    }
                }

                return options
            }

            this.wrapperStyle = baseConfig && transform(baseConfig, 'img') || {}
            this.formStyle = formConfig &&  transform(formConfig) || {}
            this.labelStyle = formConfig && formConfig.tipsConfig && transform(formConfig.tipsConfig) || {}
            this.lineStyle = formConfig && formConfig.titleConfig && transform(formConfig.titleConfig) || {}

            this.submitStyle = submitBtn && transform(submitBtn, 'img') || {}

        },

        initForm(val, list) { 
            let mappingRule = {
                addressee: 'name',
                mobile: 'phone',
                address: 'address',
                remark: 'remark',
                other: 'other'
            }
            let info = {}
            for (let key in val) {
                if (val && val[key] && mappingRule.hasOwnProperty(key)) {
                    info[mappingRule[key]] = val[key]
                }
            }
            this.submitInfo = info
            this.formList = list
        },

        submitAddressTrigger() { // 提交地址
            let status = this.validateAddress() // status 为 true 验证不通过
            if (!status) { 
                this.submitAddress(this.submitInfo)
            }
        },

        validateAddress() { // 验证地址表单信息
            let info = this.submitInfo
            for (let key in info) {
                let val = info[key]
                switch (key) {
                    case 'name':
                        if (!val) {
                            this.toast('【姓名】不能为空。')
                            return true
                        }
                        break;
                    case 'phone':
                        if (!val) {
                            this.toast('【手机号】不能为空。')
                            return true
                        } else if (val && !/1\d{10}/.test(val)) {
                            this.toast('【手机号】格式错误。')
                            return true
                        }
                        break;      
                    case 'address':
                        if (!val) {
                            this.toast('【收货地址】不能为空。')
                            return true
                        } else if (val && val.length < 10) {
                            this.toast('【收货地址】文字过短，请重新填写。')
                            return true
                        } else if (val && val.length > 300) {
                            this.toast('【收货地址】文字过长，请重新填写。')
                            return true
                        }
                        break;
                    case 'remark':
                        if (!val) {
                            this.toast('【备注】不能为空。')
                            return true
                        }  
                        break;
                    case 'other':
                        if (!val) {
                            this.toast('【其他】不能为空。')
                            return true
                        }
                        break;
                }
            }
        },

        toast(txt) { // 错误提示
            this.$toast({
                styles: {
                    maskColor: "rgba(0,0,0,0)",
                    background: "rgba(0,0,0,0.4)",
                    messageColor: "#fff"
                },
                content: txt,
                duration: 3000
            })
        },

         submitAddress(info) { // 提交物流信息
            let data = {
                recordId: this.info && this.info.recordId || ''
            }
            data = Object.assign(data, info)
            this.$emit('emitEvent', {
                type: 'submitAddress',
                data,
                options: null
            })
            this.$emit('emitEvent', {
                type: 'closeEditAddress',
                data: null,
                options: null
            })
        },

        closeEditAddress() { // 关闭添加地址
            this.$emit('emitEvent', {
                type: 'closeEditAddress',
                data: null,
                options: null
            })
        },



    },


}

</script>

<style lang="scss" scoped>
.alert {
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.8);
}

.alert .alert-area {
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.address-wrapper {
    position: relative;
}

.form-list,
.submit-btn {
    position: absolute;
}

.form-list {
    padding: 0 40px;
    width: 100%;
    box-sizing: border-box;
    .form-item {
         display: flex;
      align-items: center;
      margin-bottom: 20px;
    }
    .form-label {
        width: 30%;
    }
    .form-input,
    .form-textarea {
        flex: 1;
        width: 70%;
        padding: 8px 15px;
        border-radius: 0;
        background: none;
        border-width: 1px; 
        border-style: solid;
        color: #fff !important;
    }
}

::-webkit-input-placeholder {
    color: rgba(255, 255, 255, 0.6) !important;
}

::-webkit-textarea-placeholder {
    color: rgba(255, 255, 255, 0.6) !important;
}

.close-area {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.close-border {
    border-left: 4px dashed #fff;
    height: 100px;
}

.close-icon {
    width: 68px;
    height: 68px;
}

</style>